module.exports = require("constants");;